import { PurchaseOrder } from './types';
import { DUMMY_DATA } from './data';
import ApiService from '../../services/apiService';
import URL from '../../urls/Urls';

/**
 * TODO(you): replace the body of this function with your real API call, e.g.
 *
 *   export async function fetchDashboardData(): Promise<PurchaseOrder[]> {
 *     const res = await fetch('https://your-api.example.com/po-tracker', {
 *       headers: { Authorization: `Bearer ${TOKEN}` },
 *     });
 *     if (!res.ok) throw new Error(`Failed to load dashboard data: ${res.status}`);
 *     return res.json();
 *   }
 *
 * Expected shape: an array of PurchaseOrder records — see types.ts.
 * Each PO's `inTransit` array holds shipments already dispatched (qty + dispatchDate),
 * and `deliverySchedule` holds future planned batches (date + qty) not yet dispatched.
 */
export async function fetchDashboardData(): Promise<PurchaseOrder[]> {
  try {
    const { data } = await ApiService().client.get(URL.PLANNING.SCHEDULE);
    if (data) {
      return data.result.filter(
        (row: PurchaseOrder) => row.remainingQuantity > 0
      );
    }
  } catch (e) {
    console.error('Error:', e);
  }
  return [];
}
